import { ApiRequestError } from "@/services/api";

const CODE_MESSAGES: Record<string, string> = {
  ENTRY_DATE_LOCKED: "Pro toto datum už nelze výkaz upravit.",
  PERMISSION_DENIED: "K této akci nemáte oprávnění.",
  PROJECT_ARCHIVED: "Projekt je archivovaný.",
  BLOCK_NOT_EMPTY: "Blok obsahuje podbloky nebo položky — nejdřív je přesuňte nebo smažte.",
  CLIENT_HAS_PROJECTS: "Klient má přiřazené projekty, nelze jej smazat.",
  PROJECT_HAS_ENTRIES: "Projekt obsahuje výkazy, nelze jej smazat.",
  LIST_HAS_ENTRIES: "Soupis obsahuje vykázané položky, nelze jej smazat.",
  SECTION_NOT_EMPTY: "Sekce není prázdná — nejdřív odstraňte její položky a podsekce.",
  ITEM_HAS_ENTRIES: "Na položku už jsou vykázané práce, nelze ji smazat.",
  ENTRY_DATE_IN_FUTURE: "Výkaz nelze zadat do budoucna.",
};

/** Human-readable Czech error message for a thrown API/network error. */
export function errorMessage(error: unknown, fallback = "Něco se pokazilo"): string {
  if (error instanceof ApiRequestError) {
    if (error.code === "VALIDATION_FAILED" && Array.isArray(error.details) && error.details.length > 0) {
      return `${error.message}: ${error.details.join("; ")}`;
    }
    return CODE_MESSAGES[error.code] ?? error.message ?? fallback;
  }
  if (error instanceof Error && error.message) return error.message;
  return fallback;
}
